var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"error"},[_c('img',{attrs:{"src":require("../assets/404.png"),"alt":""}}),_c('p',[_vm._v("页面丢失，请重新登录...")]),_c('h2',[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.to}},[_vm._v("重 新 登 录")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }